import { QuestionCategories } from '@vizsla/types';
export const QUESTION_CATEGORIES_TITLES = {
    [QuestionCategories.Personal]: 'Personal Information',
    [QuestionCategories.Location]: 'Address',
    [QuestionCategories.Company]: 'Company',
    [QuestionCategories.Emergency]: 'Emergency',
    [QuestionCategories.Other]: 'Questions',
};
